import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Engines/shaderStore.js
var ShaderStore;
var init_shaderStore = __esm({
  "node_modules/@babylonjs/core/Engines/shaderStore.js"() {
    "use strict";
    ShaderStore = class _ShaderStore {
      /**
       * Gets the shaders repository path for a given shader language
       * @param shaderLanguage the shader language
       * @returns the path to the shaders repository
       */
      static GetShadersRepository(shaderLanguage = 0) {
        return shaderLanguage === 0 ? _ShaderStore.ShadersRepository : _ShaderStore.ShadersRepositoryWGSL;
      }
      /**
       * Gets the shaders store of a given shader language
       * @param shaderLanguage the shader language
       * @returns the shaders store
       */
      static GetShadersStore(shaderLanguage = 0) {
        return shaderLanguage === 0 ? _ShaderStore.ShadersStore : _ShaderStore.ShadersStoreWGSL;
      }
      /**
       * Gets the include shaders store of a given shader language
       * @param shaderLanguage the shader language
       * @returns the include shaders store
       */
      static GetIncludesShadersStore(shaderLanguage = 0) {
        return shaderLanguage === 0 ? _ShaderStore.IncludesShadersStore : _ShaderStore.IncludesShadersStoreWGSL;
      }
    };
    ShaderStore.ShadersRepository = "src/Shaders/";
    ShaderStore.ShadersStore = {};
    ShaderStore.IncludesShadersStore = {};
    ShaderStore.ShadersRepositoryWGSL = "src/ShadersWGSL/";
    ShaderStore.ShadersStoreWGSL = {};
    ShaderStore.IncludesShadersStoreWGSL = {};
  }
});

export {
  ShaderStore,
  init_shaderStore
};
